export default function auth({next, router}) {
    if (!localStorage.getItem('ptoken')) {
        return router.push({name: 'Login'});
    }

    return next();
}